import { FOOTER } from "@/constants/testIds";

const cols = [
  {
    title: "Services",
    links: ["Installation", "Modernization", "Maintenance", "Accessibility Lifts", "Emergency Repair"],
  },
  {
    title: "Company",
    links: ["About Vertex", "Heritage · Since 1996", "Careers", "Certifications", "Press"],
  },
  {
    title: "Coverage",
    links: ["Toronto", "GTA", "Hamilton", "Mississauga", "Vaughan"],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={FOOTER.root}
      className="bg-[#0A0A0A] text-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-10">
        {/* Massive wordmark */}
        <div className="border-b border-white/15 pb-10 mb-14">
          <div className="font-display font-black text-[22vw] md:text-[18vw] lg:text-[220px] leading-[0.85] tracking-[-0.05em] text-white select-none">
            VERTEX<span className="text-[#FF5E00]">.</span>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-8">
          <div>
            <div className="text-[10px] font-bold uppercase tracking-[0.28em] text-white/50 mb-4">
              Contact
            </div>
            <ul className="space-y-3 text-sm">
              <li className="text-white/80">1420 Ellesmere Rd</li>
              <li className="text-white/80">Scarborough, ON M1P 2X6</li>
              <li>
                <a href="tel:+14374940799" className="hover:text-[#FF5E00]">
                  (437) 494-0799
                </a>
              </li>
              <li>
                <a href="mailto:quotes@vertexelevators.ca" className="hover:text-[#FF5E00]">
                  quotes@vertexelevators.ca
                </a>
              </li>
            </ul>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <div className="text-[10px] font-bold uppercase tracking-[0.28em] text-white/50 mb-4">
                {c.title}
              </div>
              <ul className="space-y-3 text-sm">
                {c.links.map((l) => (
                  <li key={l}>
                    <a href="#" className="text-white/80 hover:text-[#FF5E00] transition-colors">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-white/15 flex flex-col md:flex-row md:items-center justify-between gap-4 text-xs text-white/50">
          <div>© {year} Vertex Elevators Inc. All rights reserved. TSSA #EL-1996-0847.</div>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Accessibility (AODA)</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
